import { useState } from 'react'
import { Loading } from 'src/components'
import { NoImage } from 'src/components/noImage'
import { usePostImage } from '../../hooks'
import { Wrapper } from './postImage.styles'
import { PostImageProps } from './postImage.types'

const PostImage = ({ post, aspectRatio, isEdit = false }: PostImageProps) => {
  const [imageError, setImageError] = useState(false)
  const { data: src, isError, isLoading } = usePostImage({ post })

  /**
   * This implementation will be removed when the new endpoint
   * that returns the image is implemented.
   */
  const isEmptyImage = src?.includes('default_placeholder.png') || !src || imageError

  if (isLoading) {
    return (
      <Wrapper $isEdit={isEdit} data-test="post-image">
        <Loading full />
      </Wrapper>
    )
  }

  if (isError) {
    return null
  }

  return (
    <Wrapper
      className="_bg-gray-100"
      $aspectRatio={aspectRatio}
      $isEdit={isEdit}
      data-test="post-image"
    >
      {isEmptyImage ? (
        <NoImage className="_w-full _h-full" />
      ) : (
        <img src={src} alt={post.title} loading="lazy" onError={() => setImageError(true)} />
      )}
    </Wrapper>
  )
}

export default PostImage
